import { connect } from 'react-redux';
import { downloadCognitoFormsCSV } from '../../../../../state/modules/cognitoForms/actions';

import CognitoFormsScreen from '../components/CognitoFormsScreen';

const mapStateToProps = (state) => {
  return {
    total: state.cognitoForms.get('total'),
    isLoading: state.cognitoForms.get('isLoading'),
    isDownloading: state.cognitoForms.get('isCSVDownloading'),
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    download: (order, filter, cb) => {
      dispatch(downloadCognitoFormsCSV(order, filter, cb));
    },
  };
};
const CognitoFormsScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CognitoFormsScreen);

export default CognitoFormsScreenContainer;
